import { forwardRef } from 'react'
import { RdpClient } from './RdpClient'
import { ChatOverlay } from './ChatOverlay'
import { Message } from '@renderer/types/api'
import { ThinkingState } from '@renderer/hooks/useLiveKitAgent'

interface JumpHostViewProps {
  rdpKey?: number
  messages: Message[]
  isTyping: boolean
  isSending: boolean
  inputValue: string
  onInputChange: (v: string) => void
  onSend: () => void
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void
  lkConnected: boolean
  lkConnecting: boolean
  lkTalking: boolean
  lkAgentStatus: 'idle' | 'listening' | 'processing' | 'speaking'
  lkSendScreenshot: (dataUrl: string) => void
  lkStartTalking: () => Promise<void>
  lkStopTalking: () => Promise<void>
  onEndSession: () => void
  onNewChat: () => void
  thinking?: ThinkingState | null
  assistMode: 'guide' | 'assist'
  onHelp: (() => void) | null
  helpPending: boolean
  helpRejection: string | null
}

export const JumpHostView = forwardRef<HTMLDivElement, JumpHostViewProps>(
  function JumpHostView({ onEndSession: _onEndSession, rdpKey, ...props }, ref) {
    return (
      <div ref={ref} className="relative w-full h-full" style={{ background: '#1c1712' }}>
        <RdpClient key={rdpKey} />
        <ChatOverlay {...props} />
      </div>
    )
  }
)
